module.exports = __webpack_public_path__ + "img/cadenza_allegro_natural.5bdf61f0.jpg";